<template>
    <main class="layout">
        <header class="header">
            <h1>EQ IcoMoon Library Icons</h1>
            <p v-if="data.loading">fetching data...</p>
            <p v-if="data.icons && data.icons.length === 100" class="error container">oops, try reloading</p>
            <div v-if="!data.loading && data.icons.length > 100" class="input-search">
                <input v-model="term" @input="search" type="text" placeholder="search" autofocus />
                <button v-if="term !== ''" @click="onInputClear">&times;</button>
            </div>
            <p v-if="!data.loading" class="feedback">
                <span v-if="term && !data.loading">
                    Found <strong>{{ filteredItems.count }}</strong> icons with <strong>{{ term }}</strong> in the
                    name</span
                >
                <router-link to="/about">
                    <span title="You can copy and share the URL address to share the filtered results"
                        ><i class="eq-icon eq-icon-question"></i
                    ></span>
                </router-link>
            </p>
        </header>
        <section class="search-results" v-if="!data.loading && data.icons && data.icons.length">
            <router-link
                v-for="(icon, index) in filteredItems.results"
                :key="index"
                :to="{ name: 'icon', params: { id: icon } }"
                class="icon"
            >
                <i class="eq-icon" :class="icon"></i>
                <span class="icon-name">{{ icon }}</span>
            </router-link>
        </section>
    </main>
</template>

<script>
import { reactive } from 'vue';
import IconService from '../services/IconService';
export default {
    name: 'IconList',
    data() {
        return {
            term: this.$route.query.search ? this.$route.query.search : '',
        };
    },
    setup() {
        const data = reactive({
            icons: null,
            loading: false,
            error: null,
        });
        function fetchData() {
            data.loading = true;
            let iconService = new IconService();
            iconService
                .getIcons()
                .then(result => {
                    data.icons = result;
                })
                .catch(err => {
                    data.error = err;
                })
                .then(() => {
                    data.loading = false;
                });
        }
        fetchData();
        return {
            data,
        };
    },
    computed: {
        filteredItems() {
            let filtered = { results: null, count: 0 };
            filtered.results = this.data.icons.filter(icon => icon.toLowerCase().indexOf(this.term.toLowerCase()) > -1);
            filtered.count = filtered.results.length;
            return filtered;
        },
    },
    mounted() {
        if (this.term === '') {
            this.$router.push({ query: {} });
        }
    },
    methods: {
        search(event) {
            this.$router.push({ query: { search: event.target.value } });
        },
        onInputClear() {
            this.term = '';
            this.$router.push({ query: {} });
        },
    },
    updated() {
        document.title = 'EQ IcoMoon Libary Icons';
    },
};
</script>

<style lang="scss" scoped>
.layout {
    max-width: 1400px;
    margin: 0 1em;
}
@supports (grid-area: auto) {
    @media screen and (min-width: 768px) {
        .layout {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            margin: 0 auto;
        }
        .header {
            grid-column: 2/4;
        }
        .search-results {
            grid-column: 1/5;
        }
    }
}
.input-search {
    position: relative;
    input {
        width: 100%;
        line-height: 2rem;
        font-size: 1.5rem;
        padding: 0.5rem 1rem;
    }
    button {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 18px;
        background: transparent;
        border: none;
        padding: 0.5rem;
        width: 2.5rem;
        &:hover {
            background: #efefef;
        }
    }
}
.feedback {
    &:after {
        clear: both;
    }
    span:last-child {
        float: right;
        margin-right: 0.5rem;
    }
}
@supports (grid-area: auto) {
    .search-results {
        display: grid;
        grid-gap: 1em 0.5em;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
}
.icon {
    display: flex;
    font-size: 1.1rem;
    padding: 1.75rem 1rem;
    color: inherit;
    text-decoration: none;
    &:hover {
        background: #efefef;
    }
    i.eq-icon,
    .icon-name {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    i.eq-icon {
        font-size: 2.5rem;
        padding-right: 1rem;
        width: 1.5em;
    }
}
@supports (grid-area: auto) {
    .icon {
        display: grid;
        grid-template-columns: 3.75em auto;
        i.eq-icon,
        .icon-name {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
        i.eq-icon {
            font-size: 2.5rem;
            padding-right: 0;
            justify-content: center;
            width: auto;
        }
    }
}

.error {
    color: #ed1c24;
}
</style>
